module.exports = __webpack_public_path__ + "static/media/doctors.485d33aa.jpg";